import paymentMethodFormat from '@/utils/paymentMethodFormat';
import formatPromoCodeReport from '@/utils/formatPromoCodeReport';

export default function normalizeReportFinanceCommissionTmHotelReconciliationHotelOnly(data) {
    const feesConstants = {
        ORDER_PROCESSING: 'ORDER_PROCESSING',
        TM_PROCESSING: 'TM_PROCESSING',
        INSURANCE_BONDING: 'INSURANCE_BONDING',
        BREAKAGE_BONDING: 'BREAKAGE_BONDING',
        GST_PROCESSING: 'GST_PROCESSING',
    };

    const taxesConstants = {
        INCLUDED: 'INCLUDED',
        EXCLUDED: 'EXCLUDED',
        CITY: 'CITY',
        COUNTY: 'COUNTY',
        STATE: 'STATE',
    };

    const commissionConstants = {
        PROMOTER: 'PROMOTER',
        DATA_PROVIDER: 'DATA_PROVIDER',
        CLIENT: 'CLIENT',
        GST: 'GST',
    };

    function feeTypeAmount(fees, feeType) {
        let result = fees.find((fee) => fee.type === feeType);

        return result ? result.amount : 0;
    }

    function taxTypeAmount(taxes, taxType) {
        let result = taxes.find((tax) => tax.type === taxType);

        return result ? result.amount : 0;
    }

    function commissionTypeAmount(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);
        return result ? result.amount : undefined;
    }

    function commissionTypeTax(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);
        return result?.tax;
    }

    function promoter(commissions, commissionType) {
        let result = commissions.find((commission) => commission.partnerType === commissionType);

        return result ? result.partnerName : undefined;
    }

    const hotel = data.hotel || {};
    const {
        hotelBookingNumber,
        hotelName,
        address,
        latitude,
        longitude,
        roomType,
        supplier,
        cancellationPolicies,
        stayRange,
        roomCount,
    } = hotel;

    const hotelData = {
        hotelBookingNumber: hotelBookingNumber || '',
        hotelName: hotelName,
        hotelState: address?.stateCode || '',
        hotelCity: address?.cityName || '',
        hotelCountry: address?.countryCode || '',
        hotelZipCode: address?.zipCode || '',
        hotelLatitude: latitude,
        hotelLongitude: longitude,
        roomType: roomType || '',
        bookingStatus: data.status || '',
        hotelSupplier: supplier || '',
        cancellationPolicies: cancellationPolicies || '',
        checkIn: stayRange?.checkin || '',
        checkOut: stayRange?.checkout || '',
        lengthOfStay: stayRange?.lengthOfStay || '',
        roomCount: roomCount,
    };

    return {
        orderNumber: data.orderNumber,
        orderStatus: data.orderStatus,
        id: data.id,
        createdLocalDateTime: data.createdLocalDateTime,
        createdDateTime: data.createdDateTime,
        currency: data.currency,
        settlementCurrency: data.currency,
        eventSystem: data.event.system,
        eventCode: data.event.code,
        eventPartnerProductId: data.event.partnerProductId,
        legacyEventId: data.event.legacyEventId,
        eventName: data.event.name,
        eventDate: data.event.startDate,
        promoter: promoter(data.commissions, 'PROMOTER'),
        offerName: data.event.offerName,
        venueName: data.event.venueName,
        venueState: data.event.venueState,
        venueCity: data.event.venueCity,
        venueZipCode: data.event.venueZipCode,
        eventTicketsNumber: data.event.ticketsNumber,
        totalGrossPackageValue: data.amounts.totalGrossPackageValue,
        serviceCharges: data.amounts.serviceCharges,
        revenue: data.amounts?.revenue,
        facilityFees: data.amounts.facilityFees,
        grossTotalValue: data.amounts.grossTotalValue,
        netRevenue: data.amounts.netRevenue,
        tax: commissionTypeTax(data.commissions, commissionConstants.CLIENT),
        ownedToGst: data.amounts.ownedToGst,
        totalSettlement: data.amounts.totalSettlement,
        taxes: data.amounts.taxes || '',
        totalHotelCost: data.amounts.totalHotelCost,
        hotelCostLocal: data.amounts.hotelCostLocal,
        upliftWithTMFees: data.amounts.upliftWithTMFees,
        tmProcessing: feeTypeAmount(data.fees, feesConstants.TM_PROCESSING),
        insuranceBonding: feeTypeAmount(data.fees, feesConstants.INSURANCE_BONDING),
        breakageBonding: feeTypeAmount(data.fees, feesConstants.BREAKAGE_BONDING),
        gstProcessing: feeTypeAmount(data.fees, feesConstants.GST_PROCESSING),
        promoterCommission: commissionTypeAmount(data.commissions, commissionConstants.PROMOTER),
        tmCommission: commissionTypeAmount(data.commissions, commissionConstants.CLIENT),
        tmPreSplitCommission: commissionTypeAmount(
            data.commissions,
            commissionConstants.DATA_PROVIDER
        ),
        gstCommission: commissionTypeAmount(data.commissions, commissionConstants.GST),
        supplierIncludedTax: taxTypeAmount(data.taxes, taxesConstants.INCLUDED),
        supplierExcludedTax: taxTypeAmount(data.taxes, taxesConstants.EXCLUDED),
        promoCodeAmount: data.amounts.promoCodeDiscount,
        promoCode: formatPromoCodeReport(data.promoCode, data.currency),
        packageTax: data.amounts.estimatedResellerTax,
        localTaxesAndFees: data.amounts.localTaxesAndFees,
        actualResellerTax: data.amounts.actualResellerTax,
        packageCityTax: taxTypeAmount(data.taxes, taxesConstants.CITY),
        packageCountyTax: taxTypeAmount(data.taxes, taxesConstants.COUNTY),
        channel: data.channel ? data.channel : '',
        orderType: data.type ? data.type : '',
        deviceType: data.deviceType ? data.deviceType : '',
        processor: data.paymentDetails?.processor || '',
        invoiceId: data.paymentDetails?.invoiceId || '',
        paymentMethod: paymentMethodFormat(data.paymentDetails?.paymentMethod),
        cancellationDate: data.cancellationDate || '',
        subscriptionSource: data?.subscriptionSource || '',
        subscriptionDate: data?.subscriptionDate || '',
        ...hotelData,
    };
}
